const Footer = (props: any) => {
  return (
    <div className="footer">
      <p className="copyright">2022 © TUA - upscale agency srl </p>
    </div>
  );
};
export default Footer;
